import React, { useState, useContext } from 'react';
import RegistrationRow from './RegistrationRow'
import SubscriptionRow from './SubscriptionRow'
import { SubscriptionsContext } from '../../contexts/Subscriptions'
import { RegistrationsContext } from '../../contexts/Registrations'
import map from 'lodash/map'
import difference from 'lodash/difference'

export default function InstructorCoursesTable(props) {
  const subscriptions = useContext(SubscriptionsContext);
  const registrations = useContext(RegistrationsContext);

  const instructorCourses = subscriptions.filter((subscription) => subscription.isInstructorCourse);
  const instructorCoursesDiscounted = instructorCourses.filter((instructorCourse) => !!instructorCourse.discount)
  // remove registrations if discounted full instructor courses exist
  const registrationSkus = instructorCoursesDiscounted.map((instructorCourse) => instructorCourse.sku.replace('_FULL', '_REG'))
  const registrationsFiltered = registrations.filter((registration) => {
    const index = registrationSkus.indexOf(registration.sku)
    if (index != -1) {
      registrationSkus.splice(index, 1)
      return false;
    } else {
      return true
    }
  })
  if (registrationsFiltered.length != registrations.length) {
    console.log(`hiding ${registrations.length - registrationsFiltered.length} of ${registrations.length} registrations : ${map(difference(registrations, registrationsFiltered), 'sku')}`)
  }

  return (
    <div>
      <br/><br/>
      <div><h2>Instructor-led courses</h2></div>
        <table className="responsive subscriptions"><tbody>
          { instructorCourses.length ? instructorCourses.map((instructorCourse, index) => {
            return <SubscriptionRow key={`${instructorCourse.id}_${index}`} id={instructorCourse.id} />
          }) : null }

          { registrationsFiltered.length ? registrationsFiltered.map((registration, index) => {
            return <RegistrationRow key={`${registration.id}_${index}`} id={registration.id} />
          }) : null }
        </tbody></table>
      </div>
    )
}
